module.exports = __webpack_public_path__ + "static/img/lbbg2.7ee4b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbbg2.png
// module id = O7jC
// module chunks = 0